module.exports = __webpack_public_path__ + "static/media/concat.dc49da70.png";